module.exports = __webpack_public_path__ + "img/image_profile.e2b26639.png";